<div id='modal-ocorrencias' class="modal fade bd-example-modal-lg " tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalPopoversLabel">Estatísticas</h5>     
            </div>
            <div class="modal-body text-center">
                  Ocorrencias
            </div>
            <div class="modal-footer fixed-bottom">
                <button type="button" class="btn btn-secondary mr-auto" data-dismiss="modal"><i class="fa fa-times"></i> Fechar</button>
            </div>
        </div>
    </div>
</div> 